export default __webpack_public_path__ + "static/media/Screen Placeholder - SAMSUNG.3ea67ff3.png";